/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Информация о цене перевозки
 */
export type ShippingPriceItem = {
  /**
   * Тип посылки
   */
  type: ShippingPriceItem.type
  /**
   * Цена за погрузку по адресу (в рублях)
   */
  departurePrice: string
  /**
   * Цена за выгрузку по адресу (в рублях)
   */
  destinationPrice: string
  /**
   * Цена за 1 кг (в рублях/кг)
   */
  pricePerKilogram: string
  /**
   * Минимальная цена межтерминальной перевозки
   */
  minPrice?: string
}
export namespace ShippingPriceItem {
  /**
   * Тип посылки
   */
  export enum type {
    CUSTOM = 'custom',
    PALLET = 'pallet'
  }
}
